import { registerApplication, start } from "single-spa";

registerApplication(
  "external",
  () => import("external_ui"),
  (location) => location.pathname.startsWith("/")
);

start();
